<template>
  <section class="overflow-x-auto custom-scrollbar w-full">
    <table class="table-auto bg-white w-full mt-6 min-w-max">
      <thead class="border-b bg-white border-gray-200 text-gray-400">
        <tr>
          <th class="text-left text-sm p-3">Profile</th>
          <th class="text-left text-sm p-3">Employee ID</th>
          <th class="text-left text-sm p-3">Employee Status</th>
          <th class="text-left text-sm p-3">Departement</th>
          <th class="text-left text-sm p-3">Workshift</th>
          <th class="text-left text-sm p-3">Joining date</th>
          <th class="text-left text-sm p-3">Role</th>
          <th class="text-left text-sm p-3">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(employe, index) in employee" :key="index">
          <td class="flex items-center p-3 text-sm">
            <div
              class="w-12 h-12 flex justify-center items-center rounded-full bg-zinc-400"
            >
              <h2 class="text-md text-white">
                {{
                  (employe?.emp_fullname || "-").substr(0, 1) +
                  (employe?.emp_fullname || "-").substr(
                    (employe?.emp_fullname || "-").indexOf(" ") + 1,
                    1
                  )
                }}
              </h2>
            </div>
            <div class="ml-3.5">
              <h1 class="text-md text-blue-400 mb-0">
                {{ employe?.emp_fullname || "-" }}
              </h1>
              <p class="text-sm text-gray-400">
                {{ employe?.emp_desid?.des_name || "-" }}
              </p>
            </div>
          </td>
          <td class="p-3 text-sm">
            <p class="text-sm text-gray-400">
              {{ employe?.emp_nik_karyawan || employe?._id || "-" }}
            </p>
          </td>
          <td class="p-3 text-sm">
            <p
              class="text-white flex justify-center items-center px-4 text-sm py-1 my-2 rounded-full"
              :class="
                employe?.emp_status?.empstatus_name === 'Permanent'
                  ? 'bg-blue-500'
                  : employe?.emp_status?.empstatus_name === 'Probation'
                  ? 'bg-orange-500'
                  : 'bg-red-600'
              "
            >
              {{ employe?.emp_status?.empstatus_name || "-" }}
            </p>
          </td>
          <td class="p-3 text-sm">
            <p class="text-sm text-gray-400">
              {{ employe?.emp_depid?.dep_name || "-" }}
            </p>
          </td>
          <td class="p-3 text-sm">
            <p class="text-sm text-gray-400">
              {{ employe?.emp_depid?.dep_workshift || "-" }}
            </p>
          </td>
          <td class="p-3 text-sm">
            <p class="text-sm text-gray-400">
              {{ employe?.emp_joining_data || "-" }}
            </p>
          </td>
          <td class="p-3 text-sm">
            <p class="text-sm text-gray-400">{{ employe?.role || "-" }}</p>
          </td>
          <td class="p-3 text-right relative">
            <Button
              class="p-3 shadow-none rotate-90 hover:bg-blue-100 text-primary rounded-full"
              @click="showContactEmployee(employe?._id)"
            >
              <font-awesome-icon icon="fa-ellipsis" />
            </Button>
            <div
              class="text-left absolute -top-full right-16 rounded-md bg-white shadow-md md:w-max md:h-max"
              v-if="contactEmployee === employe?._id"
            >
              <ul>
                <li
                  class="px-4 py-2 hover:bg-gray-100 hover:text-blue-400 cursor-pointer text-sm"
                  @click="goToEmployee('View details', employe)"
                >
                  View details
                </li>
                <li
                  class="px-4 py-2 hover:bg-gray-100 hover:text-blue-400 cursor-pointer text-sm"
                  @click="goToEmployee('Edit', employe)"
                >
                  Edit
                </li>
                <li
                  class="px-4 py-2 hover:bg-gray-100 hover:text-blue-400 cursor-pointer text-sm"
                  @click="goToEmployee('Assign leave', employe)"
                >
                  Assign leave
                </li>
                <li
                  class="px-4 py-2 hover:bg-gray-100 hover:text-blue-400 cursor-pointer text-sm"
                  @click="goToEmployee('Edit salary', employe)"
                >
                  Edit salary
                </li>
                <li
                  class="px-4 py-2 hover:bg-gray-100 hover:text-blue-400 cursor-pointer text-sm"
                  @click="goToEmployee('Add joining date', employe)"
                >
                  Add joining date
                </li>
                <li
                  class="px-4 py-2 hover:bg-gray-100 hover:text-blue-400 cursor-pointer text-sm"
                  @click="goToEmployee('Terminate', employe)"
                >
                  Terminate
                </li>
                <li
                  class="px-4 py-2 hover:bg-gray-100 hover:text-blue-400 text-red-600"
                >
                  Remove from employee list
                </li>
              </ul>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </section>
</template>

<script>
import Button from "./Button.vue";

export default {
  name: "TableEmployee",
  components: { Button },
  props: {
    employee: Array,
  },
  data() {
    return {
      contactEmployee: null,
    };
  },
  methods: {
    showContactEmployee(id) {
      console.log("[TableEmployee] showContactEmployee", {
        id,
        prev: this.contactEmployee,
      });
      if (this.contactEmployee === id) {
        this.contactEmployee = false;
      } else {
        this.contactEmployee = id;
      }
    },
    logAction(action, employe) {
      console.log("[TableEmployee] action", {
        action,
        id: employe?._id,
        name: employe?.emp_fullname,
        route: `/employee/${employe?._id}`,
      });
    },
    goToEmployee(action, employe) {
      this.logAction(action, employe);
      if (!employe?._id) return;
      this.$router.push(`/employee/${employe?._id}`);
    },
  },
};
</script>

<style scoped>
table thead th,
table tbody tr td {
  padding: 1rem 2rem;
}
.custom-scrollbar::-webkit-scrollbar {
  height: 2px !important;
}
.custom-scrollbar::-webkit-scrollbar-thumb {
  border-radius: 20px;
  background-color: #c6c8cc;
}
.custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background-color: #a1a1a1;
}
</style>
